import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import * as HSET from "../settings";
import { GenericHttpService } from "../../../../services/generic-http.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class WidgetCumulativeStatusService {
  apiUrl = environment.gateWayHost;
  editItem: any;
  constructor(public generic: GenericHttpService) {}

  getSLAtrendData(url, params): Observable<any> {
    const option = {
      method: "GET",
      url: url,
      query: params
    };
    return this.generic
      .httpRequest(option)
      .pipe(
        catchError(this.generic.handleError),
        map(this.generic.responseData)
      );
  }

  createChart(chartData, Options) {

    const categories = ['Total units ordered', 'Delivered', 'In Transit', 'BBND', 'To be  Invoiced'];
    const chart = JSON.parse(JSON.stringify(HSET.chartData));
    const total = (isNaN(chartData.delivered) ? 0 : chartData.delivered) + (isNaN(chartData.in_transit) ? 0 : chartData.in_transit) + (isNaN(chartData.invoiced) ? 0 : chartData.invoiced) 
    + (isNaN(chartData.to_be_invoiced) ? 0 : chartData.to_be_invoiced);
    chartData.total = total;
    chart.series[0].data[0].y = total;
    chart.series[0].data[0].myData = chartData;
    chart.series[0].data[1].y = isNaN(chartData.delivered) ? 0 :  -chartData.delivered;
    chart.series[0].data[1].myData = chartData;
    chart.series[0].data[2].y = isNaN(chartData.in_transit) ? 0 : -chartData.in_transit;
    chart.series[0].data[2].myData = chartData;
    chart.series[0].data[3].y = isNaN(chartData.invoiced) ? 0 : -chartData.invoiced;
    chart.series[0].data[3].myData = chartData;
    chart.series[0].data[4].y = isNaN(chartData.to_be_invoiced) ? 0 : -chartData.to_be_invoiced;
    chart.series[0].data[4].myData = chartData;
    return chart;
  }
}
